import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createSlider } from '../../api/apiSliders';
import toast from 'react-hot-toast';
import parseError from "../../utils/parseError";
import { useNavigate } from "react-router-dom";

export const useCreateSlider = () => {
    const queryClient = useQueryClient();
    const navigate = useNavigate();

    const {
        mutate: createSliderMutate,
        isPending,
    } = useMutation({
        mutationFn: createSlider,
        onSuccess: (data) => {
            queryClient.invalidateQueries({ queryKey: ['sliders'] });
            toast.success(data.message || 'Slider created successfully');
            navigate('/sliders');
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || 'Failed to create slider');
        },
    });

    return {
        createSliderMutate,
        isPending,
    };
};